module.exports = __webpack_public_path__ + "assets/img/logo.934c672a.png";